// extracted by mini-css-extract-plugin
export default {"login":"Login_login__t4waQ","loginForm":"Login_loginForm__K0GHu","loginButton":"Login_loginButton__K+vqJ"};